import { Component, OnInit ,ViewChild} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;

@Component({
  selector: 'app-a2-vip-score',
  templateUrl: './a2-vip-score.component.html',
  styleUrls: ['./a2-vip-score.component.scss']
})
export class A2VipScoreComponent extends GridBaseCase {
  phone = null;
  dataArrayList = [];
  code = null;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super(); }


  search(){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    console.log(1111);
    body.RequestBody = JSON.stringify({"Phone":that.phone.toString()});
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.loading = true;
        that.code = data.ResponseMessage.ErrorCode;
        that.dataArrayList = data.Status;
        if(that.dataArrayList["Gender"]){
          let sex:string= that.dataArrayList["Gender"].toString();
          switch(sex){
            case "0":
                that.dataArrayList["Gender"] = "未知";
                break;
            case "1":
                that.dataArrayList["Gender"] = "男";
                break;
            case "2":
                that.dataArrayList["Gender"] = "女";
                break;
          }
        }
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
}
